









import { Vue, Component, Prop, Watch, Emit } from "vue-property-decorator";
import { IItemParams } from "@/models/itemParams";

@Component
export default class ConfigurationItem extends Vue {
  @Prop({ type: Object, required: true }) params!: IItemParams;

  @Emit("onItemSelected")
  private click() {
    if (!this.params.isSelected) this.params.callback();
  }

  private getClass(): string {
    let result = "clickable";
    if (this.params.isSelected) result += " selected";
    return result;
  }
}
